import type { ICommand } from './ICommand';
import type { IComparable } from './IComparable';
import { compare } from './util';

interface IUndoableRepository<T> {
  save(value: T): Promise<void>;

  get(): Promise<T | null>;
}

export class UpdateCommand<T extends IComparable<T> | boolean | number | string> implements ICommand {
  constructor(
    private readonly fromValue: T,
    private readonly toValue: T,
    private readonly repository: IUndoableRepository<T>
  ) {}

  do(): void {
    this.repository.save(this.toValue).then();
  }

  undo(): void {
    this.repository.save(this.fromValue).then();
  }

  redo(): void {
    this.do();
  }

  private async currentValueEqualsTo(value: T): Promise<boolean> {
    const currentValue = await this.repository.get();
    if (currentValue === null) return false;

    return compare(currentValue, value);
  }

  async canUndo(): Promise<boolean> {
    return this.currentValueEqualsTo(this.toValue);
  }

  async canRedo(): Promise<boolean> {
    return this.currentValueEqualsTo(this.fromValue);
  }
}
